import { SvgIcon, SvgIconProps } from "@/domains/icons/svg-icon"

export const ChevronUpIcon = ({ ...rest }: SvgIconProps) => {
  return (
    <SvgIcon {...rest}>
      <path
        d="M17.9998 15C17.9998 15 13.5809 9.00001 11.9998 9C10.4187 8.99999 5.99985 15 5.99985 15"
        stroke="currentColor"
      ></path>
    </SvgIcon>
  )
}
